import { DataStudioJobTypeEnum } from "~/graphql/supergraphEnums";
import {
  hasOpcoImportPermission,
  isDataOnboardingFundAdminManager,
  isDataOnboardingUserOrManager,
} from "~/utils/userRoles";
import { JOB_TYPE_OPTIONS } from "./constants";
import type { UserRoles } from "~/types/user";

export type JobTypeOption = (typeof JOB_TYPE_OPTIONS)[number];

/**
 * Job types shown in the Dashboard job-type filter, aligned with left-nav RBAC
 * and backend list/filter allowlists for each Data Studio role.
 */
export const getJobTypeOptionsForUser = (roles: UserRoles): JobTypeOption[] => {
  const isFundAdminManager = isDataOnboardingFundAdminManager(roles);
  const isOnboardingUserOrManager = isDataOnboardingUserOrManager(roles);
  const canSeeOpcoImport =
    isFundAdminManager || isOnboardingUserOrManager || hasOpcoImportPermission(roles);

  return JOB_TYPE_OPTIONS.filter((option) => {
    switch (option.value) {
      case DataStudioJobTypeEnum.ArenaCreation:
      case DataStudioJobTypeEnum.CrmImport:
        return isOnboardingUserOrManager;
      case DataStudioJobTypeEnum.OpcoImport:
        return canSeeOpcoImport;
      case DataStudioJobTypeEnum.ArenaLock:
      case DataStudioJobTypeEnum.ArenaUnlock:
        return isFundAdminManager || isOnboardingUserOrManager;
      default:
        return false;
    }
  });
};
